












































































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "@nuxtjs/composition-api";
import { SfOverlay } from "@storefront-ui/vue";
import { storeToRefs } from "pinia";
import JetUiButton from "~/components/JetUi/atoms/JetUiButton/JetUiButton.vue";
import SfNotification from "~/components/JetUi/molecules/SfNotification/SfNotification.vue";
import { Cart, useCart, useUser } from "~/composables";
import LoginForm from "~/modules/customer/components/JetLogin/forms/LoginForm.vue";
import RegisterForm from "~/modules/customer/components/JetLogin/forms/RegisterForm.vue";
import { useCheckout, useCheckoutStore } from "~/stores/checkout";

export default defineComponent({
  name: "ClientSummary",
  components: {
    RegisterForm,
    LoginForm,
    JetUiButton,
    SfNotification,
    SfOverlay,
  },
  setup(props, { emit }) {
    const { register, loading, login, load, isAuthenticated } = useUser();
    const showRegister = ref(false);
    const showLogin = ref(false);
    const showMenu = ref(false);
    const { cart, addItem, load: loadCart, removeAll } = useCart();
    const previousCart = ref<Cart>();
    const showConfirmation = ref(false);
    const isAddingItens = ref(false);

    const checkoutStore = useCheckoutStore();
    const { loadAddresses } = useCheckout("summary", false);
    const { user, loadShippingMounted } = storeToRefs(checkoutStore);

    const userName = computed(() => {
      if (!user.value) return "";
      return `${user.value.firstname} ${user.value.lastname}`;
    });

    const userPhone = computed(() => {
      const addresses = user.value?.addresses || [];
      const firstNonNullPhone = addresses.find(
        (address: { telephone: string | null }) => address.telephone !== null
      )?.telephone;
      return firstNonNullPhone || null;
    });

    const registerForm = ref({
      rg_ie: "",
      isento: false,
      cnpj: "",
      email: "",
      celular: "",
      password: "",
      confirmPassword: "",
      date_of_birth: "",
      taxvat: "",
      gender: 4 as 1 | 2 | 3 | 4,
      firstName: "",
      lastName: "",
      segmento: "",
      vendedora: "",
      is_subscribed: false,
    });

    const loginForm = ref({
      email: "",
      password: "",
    });

    const onRegisterFormSubmit = async (form: typeof registerForm.value) => {
      registerForm.value = form;
      try {
        await register({
          user: {
            email: form.email,
            phone: form.celular,
            password: form.confirmPassword,
            prefix: "",
            suffix: "",
            date_of_birth: form.date_of_birth,
            taxvat: form.taxvat,
            gender: form.gender,
            firstname: form.firstName,
            segmento: form.segmento,
            vendedora: form.vendedora || "",
            middlename: "",
            is_subscribed: form.is_subscribed,
            lastname: form.lastName,
          },
        });
        emit("login");
        previousCart.value.items.map((cartItem) => {
          addItem({ product: cartItem.product, quantity: cartItem.quantity });
        });
        await loadAddresses();
        hideRegister();
      } catch (error) {
        console.error("Erro ao registrar usuário:", error);
      }
    };

    watch(showConfirmation, (value) => {
      emit("loading", value);
    });

    onMounted(async () => {
      if (!isAuthenticated.value) {
        previousCart.value = cart.value;
      } else {
        await loadAddresses();
      }
    });

    const hideRegister = () => {
      showRegister.value = false;
      showLogin.value = true;
    };

    const hideLogin = () => {
      showRegister.value = true;
      showLogin.value = false;
    };

    const onLoginFormSubmit = async (form: typeof loginForm.value) => {
      loginForm.value = form;
      await login({ user: { ...form } }, false);
      await load();
      await loadCart();

      if (cart.value.items.length > 0) {
        showConfirmation.value = true;
      } else {
        await mergeCart(true);
      }
      emit("login");
      await loadAddresses();
      loadShippingMounted.value = true;
    };

    const toggleMenu = () => {
      showMenu.value = !showMenu.value;
    };

    const mergeCart = async (merge: boolean) => {
      isAddingItens.value = true;
      try {
        if (!merge) {
          await removeAll({ products: cart.value.items });
        }
        await Promise.all(
          previousCart.value.items.map(async (cartItem) => {
            await addItem({
              product: cartItem.product,
              quantity: cartItem.quantity,
            });
          })
        );

        if (!merge) {
          await loadCart();
        }
      } finally {
        showConfirmation.value = false;
        isAddingItens.value = false;
      }
    };

    return {
      loading,
      isAuthenticated,
      user,
      userName,
      userPhone,
      showRegister,
      showLogin,
      registerForm,
      hideRegister,
      onRegisterFormSubmit,
      onLoginFormSubmit,
      loginForm,
      hideLogin,
      showMenu,
      toggleMenu,
      showConfirmation,
      mergeCart,
      isAddingItens,
    };
  },
});
